import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';

import { getDevice, isMobile } from '../../../../mobile/helpers';
import styles from './sidebar.scss';

const propTypes = {
  open: PropTypes.bool,
  onRequestCloseFn: PropTypes.func.isRequired,
  children: PropTypes.node,
};

const Sidebar = ({
  open,
  onRequestCloseFn,
  children,
}) => (
  <>
    <div className={classNames(
      styles.sidebar,
      { [`${styles.open}`]: open },
    )}
    >
      { React.Children.map(children, (child) => {
        if (child) {
          return React.cloneElement(child, { onRequestCloseFn });
        }
        return <></>;
      }) }
      <div
        onClick={onRequestCloseFn}
        role="button"
        tabIndex="0"
        className={classNames(
          styles.close,
          {
            [`${styles.closeIos}`]: isMobile() && getDevice() === 'iOS',
          },
        )}
      >
        <i className="far fa-times" />
      </div>
    </div>
    <div
      onClick={onRequestCloseFn}
      role="button"
      tabIndex="0"
      className={classNames(
        styles.overlay,
        { [`${styles.open}`]: open },
      )}
    />
  </>
);

Sidebar.propTypes = propTypes;

export { default as SidebarItem } from './SidebarItem';
export default Sidebar;
